function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#4A4A4A",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.399 9.782l1.001 1.002a1.6 1.6 0 010 2.263l-5.805 5.805-3.264-3.264 5.805-5.806a1.6 1.6 0 012.263 0zm-8.89 6.628l3.264 3.264-2.04.408-.408.408-2.04-1.224.816-.816.408-2.04z",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.143 21.714V24h13.714v-2.286z"
}))));